// components/dnd/subtasks/subtask/subtask.component.jsx
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { Draggable } from "react-beautiful-dnd";
import { motion } from "framer-motion";

import { db } from "../../../../firebase/firebase.utils";

import { FiSquare, FiCheckSquare } from "react-icons/fi";
import { BsTrash } from "react-icons/bs";

import {
  updateTaskDone,
  deleteTask,
} from "../../../../firebase/firebase.utils";

import "./subtask.styles.scss";

function Subtask({ parentTask, task, index, setNrOfCompleted }) {
  const [currentSubTask, setCurrentSubTask] = useState([]);
  const [doneStatus, setDoneStatus] = useState(false);
  const projectTasks = useSelector((state) => state.prjtasks.prjtasks);
  const currentUser = useSelector((state) => state.user.currentUser);

  const location = useLocation();

  const cleanPath = location.pathname.replace(/\/task\/[^/]+$/, "");
  const newPath = `${cleanPath}/task/${currentSubTask.id}`; 

  const subStyle = (isDragging, draggableStyle) => ({
    width: "100%",
    borderRadius: "4px",
    // padding: "0px 0px 0px 12px",
    marginLeft: "8px",
    background: isDragging ? "#e9f8ff" : "",
    border: isDragging ? "1px solid #c3ecff" : "",
    ...draggableStyle,
  });

  useEffect(() => {
    const currentSubTaskCheck = projectTasks?.find((t) => t.id === task);
    if (currentSubTaskCheck) {
      setCurrentSubTask(currentSubTaskCheck);
      setDoneStatus(currentSubTaskCheck.done);
    } else {
      db.collection("space")
        .doc(parentTask?.fromSpaceId)
        .collection("stations")
        .doc(parentTask?.fromStationId)
        .collection("tasks")
        .doc(task)
        .onSnapshot((doc) => {
          if (doc.exists) {
            let currenttask = doc.data();
            setCurrentSubTask(currenttask);
            setDoneStatus(currenttask.done);
          }
        });
    }
  }, [task, parentTask]);

  const handleCheck = (val) => {
    if (val) {
      setNrOfCompleted((prev => prev + 1));
    } else {
      setNrOfCompleted((prev => prev - 1));
    }
    setDoneStatus(val);
    document.getElementById("done_tone").play();
    updateTaskDone(
      currentSubTask.fromSpaceId,
      currentSubTask.fromStationId,
      currentUser.uid,
      currentSubTask.id,
      val
    );
  };
  const handleDelete = () => {
    deleteTask(
      currentSubTask.fromSpaceId,
      currentSubTask.fromStationId,
      currentSubTask.phase,
      currentSubTask.uid,
      currentSubTask
    );
  };
  return (
    <Draggable draggableId={task} index={index}>
      {(provided, snapshot) => (
        <motion.div
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
        >
          <div
            className="subtask-all"
            {...provided.draggableProps}
            ref={provided.innerRef}
            {...provided.dragHandleProps}
            style={subStyle(snapshot.isDragging, provided.draggableProps.style)}
          >
            <div className="subtask">
              {doneStatus ? (
                <div
                  className="subtask__done-true"
                  onClick={() => handleCheck(false)}
                >
                  <FiCheckSquare />
                </div>
              ) : (
                <div
                  className="subtask__done-false"
                  onClick={() => handleCheck(true)}
                >
                  <FiSquare />
                </div>
              )}
              <audio
                id="done_tone"
                src="/media/mixkit-cool-interface-click-tone-2568.wav"
              ></audio>
              <div className="subtask__content">
                <Link to={newPath}>
                  <p className={doneStatus ? "subtask__content-done" : ""}>
                    {currentSubTask?.title}
                  </p>
                </Link>
              </div>
            </div>
            <div className="subtask__delete" onClick={() => handleDelete()}>
              <BsTrash size="0.8em" />
            </div>
          </div>
        </motion.div>
      )}
    </Draggable>
  );
}

export default Subtask;
